/** Quantidades usam o separador digitado, sem conversao implicita para centavos. */
export function parseQuantidadeInput(value: string): number | null {
  const text = value.trim();
  if (!/^(?:\d+(?:[.,]\d*)?|[.,]\d+)$/.test(text)) return null;
  const quantidade = Number(text.replace(",", "."));
  return Number.isFinite(quantidade) && quantidade >= 0 ? quantidade : null;
}

export function formatQuantidadeInput(value: number): string {
  return String(value).replace(".", ",");
}
